interface Props {
  label: string;
  value: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function ContactRow({ label, value, actionLabel, onAction }: Props): JSX.Element {
  return (
    <div className="flex items-center justify-between gap-3 rounded-input bg-tg-bg p-3">
      <div className="min-w-0 flex-1">
        <p className="text-xs uppercase tracking-wide text-tg-hint">{label}</p>
        <p className="truncate text-sm font-medium text-tg-text">{value}</p>
      </div>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="flex-none rounded-input bg-brand-green/15 px-3 py-1.5 text-xs font-semibold text-brand-green"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
